<template>
  <div class="modal fade" id="bulk-update-modal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="close" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-info-circle mr-5"></i>Massenupdate</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12">
              <h4 class="text-danger">
                {{'used_filters' | translate}} <br />
                <template v-for="filter in filters">
                  <template v-if="filter.split('=')[0] !== 'count'">
                    <div class="pt-5" v-if="parseInt(filter.split('=')[1]) > 0 && filter.split('=')[1] !== ''">
                      {{filter.split('=')[0] | translate}}:
                      {{filter.split('=')[1]}}
                    </div>
                    <div class="pt-5" v-else-if="filter.split('=')[0] === 'brand' && filter.split('=')[1] !== ''">
                      {{filter.split('=')[0] | translate}}:
                      {{filter.split('=')[1]}}
                    </div>
                    <div class="pt-5" v-else-if="filter.split('=')[0] === 'channels' && (filter.split('=')[1] !== '' && filter.split('=')[1] !== '{}')">
                      {{filter.split('=')[0] | translate}}:
                      {{filter.split('=')[1]}}
                    </div>
                  </template>
                </template>
              </h4>
              <h4 class="text-danger">Von dieser Änderung sind {{productCount}} Produkte betroffen</h4>
            </div>
            <div class="col-xs-12 mt-10" v-for="(value, key) in bulkChannels">
              <div class="col-xs-4">
                <img class="img-responsive img-channel mb-10" :src="`/static/img/schuhede-${key}.svg`">
              </div>
              <div class="col-xs-8">
                <div class="btn-group pb-10" data-toggle="btn-toggle">
                  <button type="button" @click="updateChannelStatus(key, true)" :class="['btn btn-success', value ? 'active' : '']"><i class="fa fa-check mr-5"></i>{{'is_active' | translate}}</button>
                  <button type="button" @click="updateChannelStatus(key, false)" :class="['btn btn-danger', value === false ? 'active' : '']"><i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}</button>
                  <button type="button" @click="updateChannelStatus(key, null)" :class="['btn btn-info', value === null ? 'active' : '']">{{'no_changes' | translate}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <b-btn @click="sendBulk" data-dismiss="modal" type="button" class="btn btn btn-sm btn-success ml-5 pull-left"><i class="fa fa-undo mr-5"></i>{{'apply_filters' | translate}}</b-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['productCount', 'products', 'url', 'filters'],
  data () {
    return {
      bulkChannels: {
        amazon: null,
        zalando: null,
        spartoo: null,
        ebay: null,
        mirapodo: null,
        tamaris: null,
        marco_tozzi: null,
        check24: null,
        gaxsys: null,
        goertz: null,
        caprice: null
      },
      alerts: []
    }
  },
  methods: {
    sendBulk () {
      this.$parent.loading = true
      let obj = {}
      Object.keys(this.bulkChannels).forEach(k => {
        if (this.bulkChannels[k] !== null) {
          obj[k] = this.bulkChannels[k]
        }
      })
      API.put(`inventory/updateFiltered${this.url}`, {channels: JSON.stringify(obj)})
        .then(response => {
          this.$emit('alert', {type: 'success', dismiss: 4, message: response.statusText})
          Object.keys(this.bulkChannels).forEach(k => {
            this.bulkChannels[k] = null
          })
        })
        .catch(error => {
          this.$emit('alert', {type: 'danger', dismiss: 4, message: 'ERROR'})
        })
    },
    updateChannelStatus (key, status) {
      this.bulkChannels[key] = status
    }
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  watch: {
    filters () {
      Object.keys(this.bulkChannels).forEach(k => {
        this.bulkChannels[k] = null
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/BulkUpdateModal.vue